export default __webpack_public_path__ + "media/images/theme_apple/toolbar-b807908c77cf7fcd374d2ab6604c5b39.png";